module.exports = __webpack_public_path__ + "static/boxes-e05af778de035c146568bda714a0b1f0.jpg";